import React, {useEffect, useState, useRef} from 'react';
import {Icon, svgs} from 'epic-diesel-common';
import {OfflinePaymentInfo} from '../../../../../shared/types/payout/PayoutPublic';
import {PayoutState} from '../../../../reducers/payout';
import OfflinePaymentForm, {initialState, FormRef} from './OfflinePaymentForm';
import payoutActions from '../../../../actions/payout.actions';
import {useDispatch} from 'react-redux';

//@ts-ignore
import styles from './OfflinePayment.pcss';

export interface OfflinePaymentProps {
    payoutState?: PayoutState;
    messages: Record<string, string>;
}

const OfflinePayment: React.FC<OfflinePaymentProps> = ({messages, payoutState}) => {
    const dispatch = useDispatch();
    const formRef = useRef<FormRef>(null);
    const [disabled, setDisabled] = useState(true);
    const {payoutAccount} = payoutState || {};

    useEffect(() => {
        dispatch(payoutActions.getOffilePayment());
    }, []);

    useEffect(() => {
        const {accountStatus, gatewayType} = payoutAccount || {};
        const disablePayout = accountStatus && accountStatus !== 'DRAFT';
        setDisabled(disablePayout);

        if (formRef.current) {
            const form = gatewayType ? payoutAccount : initialState;
            formRef.current.setForm({...form});
        }
    }, [payoutAccount]);

    const isLoading = payoutState.loadingOfflinePayment;

    if (isLoading) {
        return (
            <div className={styles.loader}>
                <Icon className={styles.icon} icon={svgs.LOADING} fontSize="large" />
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <OfflinePaymentForm
                messages={messages}
                disabled={disabled}
                ref={formRef}
                submitForm={(payload?: OfflinePaymentInfo) => {
                    dispatch(payoutActions.saveOfflinePayment(payload));
                }}
            />
        </div>
    );
};

export default OfflinePayment;
